import { BackButton } from "@publicPortal/components/BackButton/BackButton";
import useAlertService from "@mirage/hooks/useAlertService";
import Board from "@publicPortal/components/board/Board";
import SaveBookmark from "@publicPortal/components/customBookmark/SaveBookmark";
import ResponsiveAppBar from "@publicPortal/components/responsiveAppBar/ResponsiveAppBar";
import SavedSearchService from "@publicPortal/services/SavedSearchService";
import { Filter, FilterItem } from "@shared/mirage/entityTable/Filter";
import { ISavedSearch } from "@shared/publicportal/contracts/ISavedSearch";
import { IUser } from "@shared/mirage/core/contracts/IUser";
import { UserService } from "@publicPortal/services/UserService";
import _ from "lodash";
import { memo, useCallback, useMemo, useState } from "react";
import SaveSearchModal from "../SaveSearchModal";
import EnforcementAppealsTable from "../components/EnforcementAppealsTable";

const EnforcementAppealSearchResult = memo(() => {
    const user: Partial<IUser> = UserService.getLoggedInUser();
    const [searchName, setSearchName] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const showAlert = useAlertService();
    const sp = useMemo(() => new URL(window.location.href).searchParams, []);
    const params = useMemo(() => Array.from(sp), [sp]);
    const handleOpenModal = useCallback(() => setOpenModal(true), []);
    const handleCloseModal = useCallback(() => {
        setSearchName("");
        setOpenModal(false);
    }, []);
    const filter = useMemo(() => {
        const filter = { parts: [] } as Filter;
        const filterItems: FilterItem[] = [];
        params.forEach(([key, value]) => {
            filterItems.push({ columnName: key, value, operator: "=" });
        });
        filter.parts.push({ filterItems: filterItems });
        return filter;
    }, [params]);

    async function handleSaveSearch() {
        const saveSearchService = new SavedSearchService();
        const criteria = _.fromPairs(params);
        const SaveRequest: Omit<ISavedSearch, "userId"> = {
            name: searchName,
            criteria: criteria,
            searchType: "EnforcementAppeals",
        };
        const result = await saveSearchService.createSavedSearch(SaveRequest);
        if (result.errorMsg) {
            showAlert(result.errorMsg, "error");
        } else {
            showAlert("Search saved successfully.", "success");
        }
    }

    return (
        <>
            <ResponsiveAppBar />
            <Board size="big" headerText={"Enforcement Appeals"}>
                <BackButton />
                <SaveSearchModal handleSaveSearch={handleSaveSearch} isOpen={openModal} onClose={handleCloseModal} searchName={searchName} setSearchName={setSearchName} />
                <SaveBookmark action={handleOpenModal} tooltipMessage="Save Search" userId={user?.id} />
                <EnforcementAppealsTable filter={filter} />
            </Board>
        </>
    );
});

export default EnforcementAppealSearchResult;
